import FileThumbnail, { FileThumbnailProps, thumbnailVariants } from 'components/elements/files/file-thumbnail'
import { TicketFile } from 'lib/api/ticket-files/ticket-files'
import { Skeleton } from 'lib/components/skeleton/skeleton'
import { StateScreen } from 'lib/components/state-screen/state-screen'
import { cn } from 'lib/util/cn'
import { SearchIcon } from 'lucide-react'
import { HTMLAttributes } from 'react'
interface FilesListProps extends Partial<FileThumbnailProps> {
  files: TicketFile[]
  className?: HTMLAttributes<HTMLDivElement>['className']
  isLoading?: boolean
  loadingCount?: number
}

export const FilesList = ({
  files = [],
  size = 'lg',
  className,
  isLoading = false,
  loadingCount = 20,
  ...props
}: FilesListProps) => {
  return (
    <div className={cn('tw-flex tw-flex-wrap tw-gap-4 tw-py-4', className)}>
      {!isLoading ? (
        <>
          {files.map((file) => (
            <FileThumbnail key={`${file.id}-${file.createdAt}`} file={file} size={size} {...props} />
          ))}
          {files.length === 0 && <StateScreen title="No assets found" Icon={SearchIcon} />}
        </>
      ) : (
        Array.from({ length: loadingCount }).map((_, index) => (
          <Skeleton key={index} className={cn(thumbnailVariants({ size, ...props }))} />
        ))
      )}
    </div>
  )
}
